export default __webpack_public_path__ + "static/media/Weather.97ba0a74.jpg";